<ng-container>
  <documents
    [id]="this.supplierOfferId"
    [documentComponentsName]="documentComponentName"
    [title1]="title1"
    [title2]="title2"
    [state]="state"
  >
  </documents>
</ng-container>
